import { render } from "./SliderThree.vue?vue&type=template&id=e2210336"
import script from "./SliderThree.vue?vue&type=script&lang=js"
export * from "./SliderThree.vue?vue&type=script&lang=js"

import "./SliderThree.vue?vue&type=style&index=0&id=e2210336&lang=css"
script.render = render

export default script